export default "__VITE_ASSET__kjt7TPLG__"